module.exports = __webpack_public_path__ + "static/img/gywm_zzry_img_zzzs.ac06b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gywm_zzry_img_zzzs.png
// module id = b66A
// module chunks = 21